import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Hide content visually while keeping it available to assistive technology.
 * Uses the standard sr-only technique.
 */
export function VisuallyHidden({ children, style, ...props }) {
    return (_jsx("span", { style: {
            position: 'absolute',
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: 'hidden',
            clip: 'rect(0, 0, 0, 0)',
            whiteSpace: 'nowrap',
            borderWidth: 0,
            ...style,
        }, ...props, children: children }));
}
